


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import DialogList1 from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box2/dialogList1.vue';
import DialogList2 from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box2/dialogList2.vue';
@Component({
  components: { DialogList1, DialogList2 },
})
export default class Box3 extends Vue {
  private entInfo: any = {};
  private patrolTask: any = {
    check: 0,
    notCheck: 0,
    rectify: 0,
  };
  private rectifyForm: any = {
    rectifyTotal: 0,
    notRectifyTotal: 0,
    rate: 0,
  };
  private deptId: any = '';
  private areaId: any = '';
  mounted() {
    this.getCountAllData({});
  }
  getCountAllData(opts: any) {
    const userInfo: any = localStorage.getItem('userInfo');
    const info: any = JSON.parse(userInfo);
    this.deptId = opts.deptId || info.deptId;
    this.areaId = opts.areaId || info.areaId;
    // 排查 统计数据
    zyScreenServer
      .getPatrolTaskCountData({
        deptId: this.deptId,
        areaId: this.areaId,
      })
      .then((res: any) => {
        if (res.code === '200' && res.data) {
          this.patrolTask = res.data;
        }
      })
      .catch((e: any) => {
        console.log(e);
      });
    zyScreenServer
      .getHazardCountData({
        areaId: this.areaId,
      })
      .then((res: any) => {
        if (res.code === '200' && res.data) {
          this.rectifyForm.rectifyTotal = res.data.total || 0;
          this.rectifyForm.notRectifyTotal = res.data.notHazard || 0;
          this.rectifyForm.rate = res.data.rate || 0;
        }
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
  showDialog(type: any) {
    const propData: any = {
      deptId: this.deptId,
      type,
    };
    const refName = 'DialogList1Ref';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(propData);
  }
  showDialogRectify(finishFlag: any) {
    const propData: any = {
      areaId: this.areaId,
      type: finishFlag,
    };
    const refName = 'DialogList2Ref';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(propData);
  }
}
